import { useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface Props {
  onReset: () => void | Promise<void>
  onPrint: () => void
  resetting?: boolean
  frozen?: boolean
}

export function ProposalFooter({ onReset, onPrint, resetting = false, frozen = false }: Props) {
  const [open, setOpen] = useState(false)
  return (
    <footer className="mt-6 pt-4 border-t border-border flex justify-end gap-2">
      <Button variant="ghost" disabled={frozen || resetting} onClick={() => setOpen(true)}>
        Reset draft
      </Button>
      <Button onClick={onPrint} disabled={frozen}>
        Print / Save as PDF
      </Button>

      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Reset draft?</AlertDialogTitle>
            <AlertDialogDescription>
              Reset will discard your edits and the chat history, then re-generate from current
              data.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              intent="destructive"
              onClick={() => {
                setOpen(false)
                void onReset()
              }}
            >
              Reset
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </footer>
  )
}
